<svg width="12" height="8" viewBox="0 0 12 8" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M0 8L12 0H0V8Z"/>
</svg>
